module.exports = __webpack_public_path__ + "img/icon-directory.f9307052.svg";